"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const memorizedRulesTypes_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesTypes");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
const mui_1 = require("tss-react/mui");
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const searchFilter_1 = require("data/transactions/searchFilter");
const retrievers_1 = require("data/accounts/retrievers");
const utils_1 = require("components/QuickenControls/AmountField/utils");
const constants_1 = require("utils/constants");
const rule_svg_1 = __importDefault(require("assets/rule.svg"));
const style_1 = __importDefault(require("./style"));
const MEM_RULE_STRING_LENGTH = 20;
const MEM_RULE_MEMO_LENGTH = 30;
const useStyles = (0, mui_1.makeStyles)()(style_1.default);
const ComplexRuleDetails = ({ memorizedRule, tagStatic, ruleType, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { classes, cx } = useStyles();
    const categoryName = (0, react_redux_1.useSelector)((state) => chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(state, memorizedRule === null || memorizedRule === void 0 ? void 0 : memorizedRule.coa, true));
    const renderSplitTooltipContent = () => {
        var _a, _b, _c;
        const rows = (_c = (_b = (_a = memorizedRule === null || memorizedRule === void 0 ? void 0 : memorizedRule.split) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.filter((item) => item.amount !== 0)) === null || _c === void 0 ? void 0 : _c.map((item) => {
            var _a;
            let catName = chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, item === null || item === void 0 ? void 0 : item.coa, true);
            catName = catName.length > MEM_RULE_STRING_LENGTH ? `${catName.slice(0, MEM_RULE_STRING_LENGTH)}…` : catName;
            let tagNames = ((_a = item.tags) === null || _a === void 0 ? void 0 : _a.length)
                ? (0, searchFilter_1.makeTagsString)(item.tags, false)
                : '-';
            // @ts-expect-error: 'tagNames' is possibly 'null'. 
            tagNames = tagNames.length > MEM_RULE_STRING_LENGTH ? `${tagNames.slice(0, MEM_RULE_STRING_LENGTH)}…` : tagNames;
            const formattedAmount = (0, utils_1.formatNumberAmountField)(item.amount);
            return (<tr key={item.id}>
            <td className={classes.splitTd}>{catName}</td>
            <td className={classes.splitTd}>{tagNames}</td>
            <td className={classes.splitAmountTd}>{formattedAmount}</td>
          </tr>);
        });
        return (<table className={classes.splitTable}>
        <thead>
          <tr>
            <th className={classes.splitTh}>Category</th>
            <th className={classes.splitTh}>Tags</th>
            <th className={classes.splitTh} style={{ textAlign: 'right' }}>Amount</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>);
    };
    const renderComplexRuleCategoryOrSplit = () => {
        var _a, _b;
        if (memorizedRule &&
            transactions_1.transactionsUtils.isSplitTxn(memorizedRule) &&
            ((_a = memorizedRule.split) === null || _a === void 0 ? void 0 : _a.items)) {
            return (<Tooltip_1.default title={renderSplitTooltipContent()} arrow placement="top" classes={{ tooltip: cx(classes.whiteTooltip, classes.splitToolTip), arrow: classes.whiteArrow }}>
          <span className={classes.accountHoverText}>
            <Typography_1.default variant="body2">{constants_1.APP_STRING_SPLIT}</Typography_1.default>
          </span>
        </Tooltip_1.default>);
        }
        if (memorizedRule && ((_b = memorizedRule.coa) === null || _b === void 0 ? void 0 : _b.id)) {
            return (<Typography_1.default variant="body2">
          Update category to{' '}
          <strong>{categoryName.length > MEM_RULE_STRING_LENGTH
                    ? `${categoryName.slice(0, MEM_RULE_STRING_LENGTH)}...`
                    : categoryName}
          </strong>
        </Typography_1.default>);
        }
        return (<Typography_1.default variant="body2">
        <strong>Category not found</strong>
      </Typography_1.default>);
    };
    return (<div className={classes.ruleDetailRow}>
      {/* Rule Type icon and label */}
      <div className={classes.ruleTypeBlock}>
        <img src={rule_svg_1.default} alt="Rule Type" className={classes.ruleIcon}/>
        <Typography_1.default variant="body2" className={classes.ruleTypeLabel}>{ruleType} Rule</Typography_1.default>
      </div>

      {/* IF block */}
      <div className={classes.ruleLogicBlock}>
        <Typography_1.default variant="body2" className={classes.ifAndThenLabel}>IF:</Typography_1.default>
        <div className={classes.ruleBox}>
          <div className={classes.ruleCondition}>
            <Typography_1.default variant="body2">
              <span>Payee name is </span>
              <span className={classes.ruleValue}> <strong>{memorizedRule.payee}</strong></span>
            </Typography_1.default>
          </div>

          {/* Amount cases */}
          {((_a = memorizedRule.amountCondition) === null || _a === void 0 ? void 0 : _a.amountMatchingOperator) === memorizedRulesTypes_1.MatchingOperatorTypeEnum.BETWEEN && (<div className={classes.ruleCondition}>
              <Typography_1.default variant="body2">
                <strong>AND</strong> Amount is between <br />
                <strong> {(0, utils_1.formatNumberAmountField)((_b = memorizedRule.amountCondition.amount1) !== null && _b !== void 0 ? _b : 0)} </strong>
                &nbsp;and&nbsp;
                <strong> {(0, utils_1.formatNumberAmountField)((_c = memorizedRule.amountCondition.amount2) !== null && _c !== void 0 ? _c : 0)} </strong>
              </Typography_1.default>
            </div>)}

          {((_d = memorizedRule.amountCondition) === null || _d === void 0 ? void 0 : _d.amountMatchingOperator) === memorizedRulesTypes_1.MatchingOperatorTypeEnum.GREATER_THAN && (<div className={classes.ruleCondition}>
              <Typography_1.default variant="body2">
                <strong>AND</strong> Amount is greater than <br />
                <strong> {(0, utils_1.formatNumberAmountField)((_e = memorizedRule.amountCondition.amount1) !== null && _e !== void 0 ? _e : 0)} </strong>
              </Typography_1.default>
            </div>)}

          {((_f = memorizedRule.amountCondition) === null || _f === void 0 ? void 0 : _f.amountMatchingOperator) === memorizedRulesTypes_1.MatchingOperatorTypeEnum.LESS_THAN && (<div className={classes.ruleCondition}>
              <Typography_1.default variant="body2">
                <strong>AND</strong> Amount is less than <br />
                <strong> {(0, utils_1.formatNumberAmountField)((_g = memorizedRule.amountCondition.amount1) !== null && _g !== void 0 ? _g : 0)} </strong>
              </Typography_1.default>
            </div>)}

          {((_h = memorizedRule.amountCondition) === null || _h === void 0 ? void 0 : _h.amountMatchingOperator) === memorizedRulesTypes_1.MatchingOperatorTypeEnum.EQUALS && (<div className={classes.ruleCondition}>
              <Typography_1.default variant="body2">
                <strong>AND</strong> Amount is <br />
                <strong>
                  {((_j = memorizedRule.amountCondition.amount1) !== null && _j !== void 0 ? _j : 0) >= 0 ? '' : '-'}${Math.abs((_k = memorizedRule.amountCondition.amount1) !== null && _k !== void 0 ? _k : 0)}
                </strong>
              </Typography_1.default>
            </div>)}

          {/* Account cases */}
          {memorizedRule.accountIds && memorizedRule.accountIds.length > 0 && (<div className={classes.ruleCondition}>
              <Typography_1.default variant="body2">
                <strong>AND</strong>{' '}
                {memorizedRule.accountIds.length === 1 ? (<>
                    Account is <br /> <strong>{(0, retrievers_1.getAccountString)(memorizedRule.accountIds[0])}</strong>
                  </>) : (<>
                    Accounts are {' '}
                    <br />
                    <Tooltip_1.default title={<div style={{ whiteSpace: 'pre-line' }}>
                          {memorizedRule.accountIds
                        .map((id) => (0, retrievers_1.getAccountString)(id))
                        .join('\n')}
                        </div>} arrow placement="top" classes={{ tooltip: classes.whiteTooltip, arrow: classes.whiteArrow }}>
                      <span className={classes.accountHoverText}>
                        <strong>{memorizedRule.accountIds.length} accounts selected</strong>
                      </span>
                    </Tooltip_1.default>
                  </>)}
              </Typography_1.default>
            </div>)}
        </div>
      </div>

      {/* THEN block */}
      <div className={classes.ruleLogicBlock}>
        <Typography_1.default className={classes.ifAndThenLabel}>THEN:</Typography_1.default>
        <div className={classes.ruleBox}>
          <div className={classes.ruleCondition}>
            {renderComplexRuleCategoryOrSplit()}
          </div>
          {memorizedRule.tags && tagStatic && (<div className={classes.ruleCondition}>
              <Typography_1.default variant="body2">
                Tag to{' '}
                <strong>{tagStatic.length > MEM_RULE_STRING_LENGTH
                ? `${tagStatic.slice(0, MEM_RULE_STRING_LENGTH)}...`
                : tagStatic}
                </strong>
              </Typography_1.default>
            </div>)}
          {memorizedRule.memo && (<div className={classes.ruleCondition}>
              <Typography_1.default variant="body2">
                Memo to{' '}
                <strong>
                  {memorizedRule.memo.length > MEM_RULE_MEMO_LENGTH
                ? `${memorizedRule.memo.slice(0, MEM_RULE_MEMO_LENGTH)}...`
                : memorizedRule.memo}
                </strong>
              </Typography_1.default>
            </div>)}
          {memorizedRule.payeeOverride && (<div className={classes.ruleCondition}>
              <Typography_1.default variant="body2">
                AND rename payee to <br />
                <strong>
                  {memorizedRule.payeeOverride.length > MEM_RULE_STRING_LENGTH
                ? `${memorizedRule.payeeOverride.slice(0, MEM_RULE_STRING_LENGTH)}...`
                : memorizedRule.payeeOverride}
                </strong>
              </Typography_1.default>
            </div>)}
        </div>
      </div>
    </div>);
};
exports.default = ComplexRuleDetails;
